/* Video gallery — Aborder Products.
 *
 * Click-to-load facades. Every card ships as a poster and a play button; the
 * iframe or the <video> is created only when someone presses play.
 *
 * The reason is weight. A YouTube iframe pulls roughly 900KB of script and
 * opens connections to several third-party origins before the visitor has
 * decided to watch anything; nine of them on one page is most of a page budget
 * spent on video nobody has asked for yet. A facade costs one poster image
 * that was going to load anyway.
 *
 * FAIL-OPEN: the markup is complete without this file. A hosted card still has
 * a real <video> with controls, and an external card still has a visible link
 * to the video on its own host. This script only upgrades the interaction; it
 * is never what makes a card work.
 *
 * The embed URL is built in Liquid and read from data-video-embed, so nothing
 * here has to parse a URL at runtime.
 */
(function () {
  'use strict';

  function activate(card) {
    if (card.__vgActive) return;
    card.__vgActive = true;

    var target = card.querySelector('[data-video-target]');
    var button = card.querySelector('[data-video-play]');
    if (!target) return;

    card.classList.add('video-card--active');
    target.hidden = false;

    if (card.getAttribute('data-video-kind') === 'hosted') {
      var video = target.querySelector('video');
      if (video) {
        /* A play() rejection is normal — an autoplay policy, a codec, a user
           who navigated away mid-click. The controls are already visible, so
           the fallback is simply that they press play again. */
        var attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
      }
    } else {
      var src = card.getAttribute('data-video-embed');
      if (!src) return;
      /* The title moved into the caption strip on the poster, so it is the
         strip's label element that carries it now. */
      var label = card.querySelector('.caption-strip__label');
      var frame = document.createElement('iframe');
      frame.setAttribute('src', src);
      frame.setAttribute('title', label ? label.textContent.trim() : 'Video');
      frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      frame.setAttribute('allowfullscreen', 'allowfullscreen');
      frame.setAttribute('loading', 'lazy');
      frame.className = 'video-card__iframe';
      target.appendChild(frame);
    }

    /* The button has done its job and the player now owns the surface, so it
       must not stay in the tab order sitting on top of the controls. */
    if (button) button.remove();
  }

  function wire(root) {
    var cards = root.querySelectorAll('[data-video-card]');
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        if (card.__vgBound) return;
        card.__vgBound = true;

        /* The script is running, so the no-JS link is redundant — remove it
           rather than leaving two ways to start the same video. */
        var fallback = card.querySelector('.video-card__fallback');
        if (fallback) fallback.remove();
        card.classList.add('video-card--enhanced');

        var button = card.querySelector('[data-video-play]');
        if (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            activate(card);
          });
        }
      })(cards[i]);
    }
  }

  function init() {
    try {
      wire(document);
    } catch (e) {
      /* Any failure leaves the markup exactly as the server sent it: posters,
         real controls on hosted video, and working links on external video. */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
